import { Appointment } from '@/types/appointment';

export type AppointmentGroup =
  | { type: 'single'; appointment: Appointment }
  | { type: 'recurrence'; enrollmentId: string; appointments: Appointment[] };

/**
 * Agrupa ocorrências da mesma recorrência (mesmo enrollmentId) numa única
 * entrada, preservando a posição da primeira ocorrência de cada grupo — a
 * lista já vem ordenada por data, então o grupo aparece onde o próximo
 * encontro apareceria sozinho.
 */
export function groupAppointmentsByRecurrence(list: Appointment[]): AppointmentGroup[] {
  const groups: AppointmentGroup[] = [];
  const indexByEnrollment = new Map<string, number>();

  for (const appointment of list) {
    const enrollmentId = appointment.enrollmentId;
    if (!enrollmentId) {
      groups.push({ type: 'single', appointment });
      continue;
    }

    const existingIndex = indexByEnrollment.get(enrollmentId);
    if (existingIndex === undefined) {
      indexByEnrollment.set(enrollmentId, groups.length);
      groups.push({ type: 'recurrence', enrollmentId, appointments: [appointment] });
    } else {
      const group = groups[existingIndex];
      if (group.type === 'recurrence') group.appointments.push(appointment);
    }
  }

  // Recorrência com uma única ocorrência na lista não ganha nada em ser
  // agrupada — vira ruído (esconde as ações atrás de um toque a mais).
  return groups.map((group) =>
    group.type === 'recurrence' && group.appointments.length === 1
      ? { type: 'single', appointment: group.appointments[0] }
      : group,
  );
}
